import { theme } from '@lojinha/design-system'
import { PurchasesVariants } from '../../core/purchase-variants'
import { SectionBannerVariants } from '../../core/section-banner-variants'
import { t } from '../../dictionary'

export const bannerStyles: Record<
  PurchasesVariants | SectionBannerVariants,
  {
    backgroundColor: string
    titleFontColor: keyof typeof theme.colors
    subtitleFontColor: keyof typeof theme.colors
    title: string
    subtitle?: string
    buttonTitle?: string
    backgroundButton?: keyof typeof theme.colors
    fontColorButton?: keyof typeof theme.colors
    buttonAriaLabel?: string
  }
> = {
  [PurchasesVariants.MyPurchases]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'black',
    subtitleFontColor: 'gray700',
    title: t.myPurchases,
    subtitle: t.myPurchasesSubtitle,
  },
  [PurchasesVariants.Approved]: {
    backgroundColor: theme.colors.blueberryDark,
    titleFontColor: 'blueberryLightSupport',
    subtitleFontColor: 'blueberryLightSupport',
    title: t.approvedOrder,
    subtitle: t.myPurchasesSubtitle,
    buttonTitle: t.changeDeliveryDateBtn,
    backgroundButton: 'white',
    fontColorButton: 'blueberryDark',
  },
  [PurchasesVariants.Returned]: {
    backgroundColor: theme.colors.acaiLight,
    titleFontColor: 'acaiLightSupport',
    subtitleFontColor: 'acaiLightSupport',
    title: t.returnedOrder,
    subtitle: t.myPurchasesSubtitle,
    buttonTitle: t.changeDeliveryDateForReturnedOrderBtn,
    backgroundButton: 'white',
    fontColorButton: 'acaiLight',
  },
  [PurchasesVariants.WaitingPayment]: {
    backgroundColor: theme.colors.acaiDark,
    titleFontColor: 'acaiDarkSupport',
    subtitleFontColor: 'acaiDarkSupport',
    title: t.waitingPaymentOrder,
    subtitle: t.myPurchasesSubtitle,
    buttonTitle: t.seeBankSlip,
    backgroundButton: 'white',
    fontColorButton: 'acaiDark',
  },
  [PurchasesVariants.WaitingAuthorization]: {
    backgroundColor: theme.colors.acaiDark,
    titleFontColor: 'acaiDarkSupport',
    subtitleFontColor: 'acaiDarkSupport',
    title: t.waitingAuthorization,
    subtitle: t.myPurchasesSubtitle,
    buttonTitle: t.changeDeliveryDateBtn,
    backgroundButton: 'white',
    fontColorButton: 'acaiDark',
  },
  [PurchasesVariants.Canceled]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'error',
    subtitleFontColor: 'error',
    title: t.refusedPayment,
    buttonTitle: t.rebuy,
    buttonAriaLabel: t.rebuyAriaLabel,
    backgroundButton: 'success',
    fontColorButton: 'white',
    subtitle: t.myPurchasesSubtitle,
  },
  [PurchasesVariants.Done]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'gray700',
    subtitleFontColor: 'gray700',
    title: t.deliveredOrder,
    buttonTitle: t.rebuy,
    buttonAriaLabel: t.rebuyAriaLabel,
    backgroundButton: 'success',
    fontColorButton: 'white',
    subtitle: t.myPurchasesSubtitle,
  },
  [PurchasesVariants.CanceledAfter3Days]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'gray700',
    subtitleFontColor: 'gray700',
    title: t.deliveredOrder,
    subtitle: t.myPurchasesSubtitle,
  },
  [SectionBannerVariants.EditProfile]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'black',
    subtitleFontColor: 'gray700',
    title: t.editProfile,
    subtitle: t.editProfileSubtitle,
  },
  [SectionBannerVariants.SomethingWentWrong]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'black',
    subtitleFontColor: 'gray700',
    title: t.survey.somethingWentWrong.title,
    subtitle: t.survey.somethingWentWrong.subtitle,
  },
  [SectionBannerVariants.SurveyActive]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'black',
    subtitleFontColor: 'gray700',
    title: t.survey.active.title,
  },
  [SectionBannerVariants.SurveyAnswered]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'black',
    subtitleFontColor: 'gray700',
    title: t.survey.answered.title,
    subtitle: t.survey.answered.subtitle,
  },
  [SectionBannerVariants.SurveyAlreadyFilled]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'black',
    subtitleFontColor: 'gray700',
    title: t.survey.alreadyFilled.title,
    subtitle: t.survey.alreadyFilled.subtitle,
  },
  [SectionBannerVariants.SurveyExpired]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'black',
    subtitleFontColor: 'gray700',
    title: t.survey.expired.title,
    subtitle: t.survey.expired.subtitle,
  },
  [SectionBannerVariants.SurveyLoading]: {
    backgroundColor: theme.colors.gray100,
    titleFontColor: 'black',
    subtitleFontColor: 'gray700',
    title: t.survey.loading.title,
    subtitle: t.survey.loading.subtitle,
  },
}
